export enum FormInfoGroup {
  ContactInfo = 'Name, email, phone number',
  MailingAddress = 'Mailing Address',
  DemographicInfo = 'Demographic Information',
  ProfessionalInfo = 'Professional Information',
  TeamInfo = 'Team'
}
